export default __webpack_public_path__ + "static/media/marker-blue-yellow.56468928.png";